// Signing out has to take the offline copy with it: the service worker keeps
// the last API responses so the app reads offline, and those are one user's
// expenses. The outbox is deliberately left alone — those writes are still
// owed to the account that queued them.
export async function logout(): Promise<void> {
  try {
    await fetch("/api/auth/logout", { method: "POST" });
  } finally {
    try {
      await Promise.all(
        ["api", "receipt-images"].map((name) => caches.delete(name)),
      );
    } catch {
      /* no Cache Storage (private mode, http) — nothing to purge */
    }
    location.href = "/login";
  }
}
